import React from "react";

export default function TermsOfService() {
  const bottomEndRef = React.useRef<HTMLParagraphElement>(null);

  const scrollToBottom = () => {
    bottomEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div style={{ padding: 5 }}>
      <div style={{ fontWeight: "bold", fontSize: "16px", paddingBottom: 20 }}>
        <h1 style={{ fontSize: "34px" }}>Terms of Service</h1>
        PLEASE READ ALL OF THE FOLLOWING TERMS AND CONDITIONS OF SERVICE FOR
        THIS WEB SITE BEFORE USING THIS SITE. BY CONTINUING TO ACCESS, LINK TO,
        OR USE THIS SITE, OR ANY SERVICE ON THIS SITE, YOU SIGNIFY YOUR
        ACCEPTANCE THESE Terms of Service, INCLUDING WITHOUT LIMITATION, THE
        ARBITRATION AGREEMENT AND CLASS ACTION WAIVER DESCRIBED IN PARAGRAPH 14
        BELOW.
      </div>
      <div>
        <h2>A. General Terms</h2>
        1. User Consent to the Terms of Service. You represent that you have
        read and agree to be bound by the Terms of Service. 2. Intellectual
        Property. This Web site, and all of the content it contains, or may in
        the future contain, including but not limited to text, content,
        photographs, video, audio and graphics, goods, designs, information,
        applications, software, music, audio files, articles, directories,
        guides, photographs as well as the trademarks, service marks, trade
        names, trade dress, copyrights, logos, domain names, code, patents
        and/or any other form of intellectual property (collectively, the
        “Service”) that relates to this site, are owned by or licensed by
        Longbow or other third parties and are protected from any unauthorized
        use, copying and dissemination by copyrights, trademarks, service marks,
        international treaties, and/or other proprietary rights and laws of the
        U.S. and other countries. The Service is also protected as a collective
        work or compilation under U.S. copyright and other laws and treaties.
        All individual articles, columns and other elements making up the
        Service are also copyrighted works. You agree to abide by all applicable
        copyright and other laws, as well as any additional copyright notices or
        restrictions contained in the Service. You acknowledge that the Service
        has been developed, compiled, prepared, revised, selected, and arranged
        by Longbow, its general and limited partners, and its subsidiaries, and
        their respective general partners and affiliates (collectively
        “Longbow”) and others (including certain other information sources)
        through the application of methods and standards of judgment developed
        and applied through the expenditure of substantial time, effort, and
        money and constitutes valuable intellectual property of Longbow and such
        others. You agree to protect the proprietary rights of Longbow and all
        others having rights in the Service during and after the term of this
        agreement and to comply with all reasonable written requests made by
        Longbow or its suppliers and licensors of content, equipment, or
        otherwise (“Suppliers”) to protect their and others’ contractual,
        statutory, and common law rights in the Service. You agree to notify
        Longbow in writing promptly upon becoming aware of any unauthorized
        access or use of the Service by any individual or entity or of any claim
        that the Service infringes upon any copyright, trademark, or other
        contractual, statutory, or common law rights. All present and future
        rights in and to trade secrets, patents, copyrights, trademarks, service
        marks, know-how, and other proprietary rights of any type under the laws
        of any governmental authority, domestic or foreign, including rights in
        and to all applications and registrations relating to the Service (the
        “Intellectual Property Rights”) shall, as between you and Longbow, at
        all times be and remain the sole and exclusive property of Longbow. All
        present and future rights in and title to the Service (including the
        right to exploit the Service and any portions of the Service over any
        present or future technology) are reserved to Longbow for its exclusive
        use. Except as specifically permitted by the Terms of Service, you may
        not copy or make any use of the Service or any portion thereof. Except
        as specifically permitted herein, you shall not use the Intellectual
        Property Rights or the Service, or the names of any individual
        participant in, or contributor to, the Service, or any variations or
        derivatives thereof, for any purpose, without Longbow’s prior written
        approval. 3. Restrictions on Use. You may not use the Service for any
        illegal purpose, for the facilitation of the violation of any law or
        regulation, or in any manner inconsistent with the Terms of Service. You
        agree to use the Service solely for your own noncommercial use and
        benefit, and not for resale or other transfer or disposition to, or use
        by or for the benefit of, any other person or entity. You agree not to
        use, transfer, distribute, or dispose of any information contained in
        the Service in any manner that could compete with the business of
        Longbow or any of its suppliers. Except as expressly permitted by
        Longbow in writing you may not copy, reproduce, recompile, decompile,
        disassemble, reverse engineer, distribute, publish, display, perform,
        modify, upload to, create derivative works from, transmit, transfer,
        sell, license, upload, edit post, frame, link, or in any way exploit any
        part of the Service, except that you may download material from the
        Service and/or make one print copy for your own personal, noncommercial
        use, provided that you retain all copyright and other proprietary
        notices. You may not recirculate, redistribute or publish the analysis
        and presentation included in the Service without Longbow’s prior written
        consent. Nothing contained in the Terms of Service or on this site
        should be construed as granting, by implication, estoppel or otherwise,
        any license or right to use any Service in any manner without the prior
        written consent of Longbow or such third party that may own the Service
        or intellectual property displayed on this site. UNAUTHORIZED USE,
        COPYING, REPRODUCTION, MODIFICATION, PUBLICATION, REPUBLICATION,
        UPLOADING, FRAMING, DOWNLOADING, POSTING, TRANSMITTING, DISTRIBUTING,
        DUPLICATING OR ANY OTHER MISUSE OF ANY OF THE SERVICE IS STRICTLY
        PROHIBITED. Any use of the Service other than as permitted by the Terms
        of Service will violate the Terms of Service and may infringe upon our
        rights or the rights of the third party that owns the affected Service.
        You agree to report any violation of the Terms of Service by others that
        you become aware of. You may use the “e-mail this article” function
        solely to inform others about a Longbow News article, and you shall
        immediately cease using this function with regard to recipients who have
        requested not to receive such information. You may not offer any part of
        the Service for sale or distribute it over any other medium including
        but not limited to over-the-air television or radio broadcast, a
        computer network or hyperlink framing on the internet without the prior
        written consent of Longbow. The Service and the information contained
        therein may not be used to construct a database of any kind. Nor may the
        Service be stored (in its entirety or in any part) in databases for
        access by you or any third party or to distribute any database Services
        containing all or part of the Service. You may not use the Service in
        any way to improve the quality of any data sold or contributed by you to
        any third party. You may not input, distribute, upload, post, email,
        transmit or otherwise make available any content through the Service
        that: (i) is promotional in nature, including solicitations for funds or
        business, without the prior written authorization of Longbow, or
        constitutes junk mail, spam, chain letters, pyramid schemes or the like;
        (ii) is unlawful, harmful, threatening, abusive, harassing, tortious,
        defamatory, vulgar, obscene, libelous, invasive of another’s privacy,
        hateful, or racially, ethnically or otherwise objectionable; (iii) you
        do not have the right to make available under any law or under
        contractual or fiduciary relationships (such as inside information,
        proprietary and confidential information learned or disclosed as part of
        employment relationships or under nondisclosure agreements); (iv)
        infringes any patent, trademark, trade secret, copyright or other
        proprietary rights of any party; (v) contains software viruses or any
        other computer code, files or programs designed to interrupt, destroy or
        limit the functionality of any computer software or hardware, or
        telecommunications equipment; (vi) is harmful to minors; or (vii)
        constitutes the personally identifiable information of any other person
        that such person has not authorized you to disclose. You may not use any
        of the trademarks, trade names, service marks, copyrights, or logos of
        Longbow in any manner which creates the impression that such items
        belong to or are associated with you or are used with Longbow’s consent,
        and you acknowledge that you have no ownership rights in and to any of
        such items. You may neither interfere with nor attempt to interfere with
        nor otherwise disrupt the proper working of the Service, any activities
        conducted on or through the Service or any servers or networks connected
        to the Service. You may neither obtain nor attempt to obtain through any
        means any materials or information on the Service that have not been
        intentionally made publicly available either by public display on the
        Service or through accessibility by a visible link on the Service. You
        shall not violate the security of the Service or attempt to gain
        unauthorized access to the Service, data, materials, information,
        computer systems or networks connected to any server associated with the
        Service, through hacking, password timing or any other means. You may
        neither take nor attempt any action that, in the sole discretion of
        Longbow, imposes or may impose an unreasonable or disproportionately
        large load or burden on the Service or the infrastructure of the
        Service. You shall not use or attempt to use any “scraper,” “robot,”
        “bot,” “spider,” “data mining,” “computer code,” or any other automate
        device, program, tool, algorithm, process or methodology to access,
        acquire, copy, or monitor any portion of the Service, any data or
        content found on or accessed through the Service, or any other Service
        information without the prior express written consent of Longbow. You
        may not forge headers or otherwise manipulate identifiers in order to
        disguise the origin of any other content. 4. License. (i) You acquire
        absolutely no rights or licenses in or to the Service and materials
        contained within the Service other than the limited right to utilize the
        Service in accordance with the Terms of Service. Should you choose to
        download content from the Service, you must do so in accordance with the
        Terms of Service. Such download is licensed to you by Longbow ONLY for
        your own personal, noncommercial use in accordance with the Terms of
        Service and does not transfer any other rights to you. (ii) Longbow’s
        company policy does not allow it to accept or consider creative ideas,
        suggestions, or materials other than those it has specifically requested
        (see below). Accordingly, we ask that you do not send us any original
        creative materials that you expect to be compensated for or that you
        would like to keep private. If you nevertheless choose to make any such
        submission, Longbow may freely use the submission, in whole or in part,
        for any purpose without any obligation to you. Without limiting the
        generality of the foregoing, if you submit material (i.e.,
        user-generated content, including, but not limited to: comments, text,
        video, audio, and photographs) to this site, any other site owned by
        Longbow and its affiliates or to Longbow or its representative, or if
        you send us creative suggestions, ideas, notes, concepts, or any other
        information (each, a “Submission” and collectively, the “Submissions”),
        despite our request that you not send us any unsolicited Submissions or
        other creative materials, the Submission will be treated as
        non-confidential and non-proprietary in each instance. None of the
        Submissions shall be subject to any obligation of confidence on the part
        of Longbow, and Longbow shall not be liable for any use or disclosure of
        any Submissions. Unless Longbow indicates otherwise, you grant to
        Longbow a perpetual, nonexclusive, irrevocable, fully paid,
        royalty-free, sublicensable and transferable (in whole or in part)
        worldwide right and license in any and all media, now known or later
        developed, to use, publish, reproduce, display, modify, transmit
        digitally, create derivative works based upon, distribute, copy, and
        otherwise exploit Submissions for any purpose whatsoever (including,
        without limitation, advertising, commercial, promotional and publicity
        purposes) in Longbow’s discretion without additional notice, attribution
        or consideration to you or to any other person or entity. You also
        permit any other user to access, store, or reproduce Submissions for
        that user’s personal use. You grant Longbow the right to use the name
        that you submit in connection with Submissions. You agree and understand
        that Longbow is not obligated to use any Submission you make to this
        site or Longbow and you have no right to compel such use. You hereby
        acknowledge and agree that your relationship with Longbow is not a
        confidential, fiduciary, or other special relationship, and that your
        decision to submit any material to Longbow does not place Longbow in a
        position that is any different from the position held by members of the
        general public with regard to your Submission. You represent and warrant
        that you are the original author or creator of the Submissions (except
        as expressly indicated otherwise), that neither the permission nor
        consent of any other person or entity is required to enable Longbow to
        legally use your Submission in accordance with this license and that
        Longbow’s use of your Submission in accordance with this license will
        not violate or infringe upon the rights of any person or entity, and
        that you own or otherwise control all of the rights to the Submissions
        that you submit; that the Submissions you submit are truthful and
        accurate; that use of the Submissions you supply does not violate this
        Terms of Service and will not cause injury to any person or entity; and
        that you will indemnify Longbow and its Suppliers, agents, directors,
        officers, employees, representatives, successors, and assigns for all
        claims resulting from Submissions you supply. Longbow and its Suppliers,
        agents, directors, officers, employees, representatives, successors, and
        assigns disclaim any responsibility and assume no liability for any
        Submissions submitted by you or any third party. You hereby irrevocably
        waive, release and give up any claim that any use of such Submission
        violates any of your rights, including, without limitation, copyrights,
        trademarks, moral rights, privacy rights, proprietary or other property
        rights, publicity rights, or right to credit for the material or ideas,
        and forever release and discharge Longbow and its licensees from any and
        all claims you may have in connection with Longbow’s use of your
        Submission in accordance with this license. Finally, you acknowledge
        that, with respect to any claim you may have relating to or arising out
        of Longbow’s actual or alleged exploitation or use of any material you
        submit to this site and/or Longbow, the damage, if any, thereby caused
        will not be irreparable or otherwise sufficient to entitle you to
        injunctive or other equitable relief or to in any way enjoin the
        exploitation or other use of any Longbow product or service based on or
        allegedly based on the material, and your rights and remedies in any
        such event shall be strictly limited to the right to recover damages, if
        any, in an action at law. You agree that this authorization contains the
        full and complete understanding between Longbow and you regarding
        Longbow’s use of your Submission and cannot be modified except by a
        document signed by Longbow and you. 5. Fees and Payments. Longbow
        reserves the right at any time to charge fees for access to portions of
        the Service or the Service as a whole. This includes, but is not limited
        to Longbow’s subscription service, which allows anonymous and registered
        users to access a limited amount of content each month after requiring
        payment for access. Additional information regarding the terms of the
        subscription service may be found under Subscription Terms below. If at
        any time Longbow requires a fee for portions of the Service or the
        Service as a whole, Longbow will require you to register and create an
        account. The decision to provide the information required to create an
        account is purely voluntary and optional; however, if you elect not to
        provide such information, you will not be able to access certain content
        or participate in certain parts or features of this site. You shall pay
        all fees and charges incurred through your account at the rates in
        effect for the billing period in which such fees and charges are
        incurred, including but not limited to charges for any products or
        services offered for sale through the Service by Longbow or by any other
        vendor or service provider. All fees and charges shall be billed to you,
        and you shall be solely responsible for their payment. You shall pay all
        applicable taxes relating to the use of the Service through your
        account, and the purchase of any other products or services. Certain
        portions of the Service or the Service as a whole may require a prepaid
        fee (“Prepaid Fee”), which may be modified from time to time in
        Longbow’s sole discretion. The Prepaid Fee, and all taxes and other fees
        related thereto will be paid by you in advance. In no event will you
        receive any portions of the Service or the Service as a whole if a
        Prepaid Fee is required unless Longbow receives all fees and charges
        payable by you, including the Prepaid Fee. 6. Registration and Account
        Creation. As part of the registration and account creation process
        necessary to obtain access to certain portions of the Service, including
        those portions that require a fee or payment for access, you will select
        a username and a password. You will provide Longbow with certain
        registration information, all of which must be accurate, truthful, and
        updated. You shall not: (i) select a username already used by another
        person; (ii) create an account for anyone other than yourself without
        permission; (iii) use a username in which another person has rights
        without such person’s authorization; or (iv) use a username or password
        that Longbow, in its sole discretion, deems offensive or inappropriate.
        Longbow reserves the right to deny creation of your account based on
        Longbow’s inability to verify the authenticity of your registration
        information. You shall be solely responsible for maintaining the
        confidentiality of your password. You shall immediately notify Longbow
        by submitting FEEDBACK of any known or suspected unauthorized use(s) of
        your account, or any known or suspected breach of security, including
        loss, theft, or unauthorized disclosure of your password or credit card
        information. You are fully responsible for all usage and activity on
        your account, including, but not limited to, use of the account by any
        third party authorized by you to use your username and password. You
        agree you will not sell, transfer or assign your membership or any
        membership rights. The use of your account by any individual under age
        eighteen (18) is strictly prohibited. If the computer system on which
        you accessed the Service is sold or transferred to another party, you
        warrant and represent that you will delete all cookies and software
        files obtained by or through use of the Service. Longbow reserves the
        right to terminate your account, in its sole discretion, at any time
        without notice. If we disable your account, you agree that you will not
        create another one without our permission. You may terminate your
        account at any time by submitting feedback. Upon termination, you will
        receive an automated confirmation via e-mail that the request was
        received, and your account will be terminated within five (5) business
        days. You are responsible for all charges incurred up to the time the
        account is terminated. Notwithstanding anything else herein, Longbow
        reserves the right to pursue any and all claims against any user of your
        account. You agree to maintain only one account with the Service at any
        time and certify that you currently have no other account(s) with the
        Service. 7. Disclaimer and Limitation of Liability. (i) YOU AGREE THAT
        YOUR USE OF THE SERVICE IS AT YOUR SOLE RISK AND ACKNOWLEDGE THAT THE
        SERVICE AND ANYTHING CONTAINED WITHIN THE SERVICE, INCLUDING, BUT NOT
        LIMITED TO, CONTENT, SERVICES, GOODS, OR ADVERTISEMENTS ARE PROVIDED “AS
        IS” AND “AS AVAILABLE,” AND THAT LONGBOW MAKES NO WARRANTY OF ANY KIND,
        EXPRESS OR IMPLIED, AS TO THE SERVICE, INCLUDING, BUT NOT LIMITED TO,
        MERCHANTABILITY, NON-INFRINGEMENT, TITLE, OR FITNESS FOR A PARTICULAR
        PURPOSE OR USE OR THOSE ARISING BY STATUTE OR OTHERWISE IN LAW FROM A
        COURSE OF DEALING OR USAGE OF TRADE. LONGBOW DOES NOT WARRANT THAT THE
        AVAILABILITY OF OR THE FUNCTIONS CONTAINED IN THIS SITE OR THE SERVICE
        WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR
        THAT THIS SITE OR THE SERVER THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES
        OR OTHER HARMFUL COMPONENTS OR THAT THIS SITE, THE SERVICE OR SERVER DO
        NOT VIOLATE ANY PATENT OR OTHER INTELLECTUAL PROPERTY RIGHTS OF ANY
        PERSON OR ENTITY. LONGBOW DOES NOT WARRANT OR MAKE ANY REPRESENTATIONS
        REGARDING THE USE OR THE RESULTS OF THE USE OF THIS SITE OR THE SERVICE
        IN TERMS OF THEIR CORRECTNESS, ACCURACY, RELIABILITY, OR OTHERWISE. YOU
        (AND NOT LONGBOW) ASSUME THE ENTIRE COST OF ALL NECESSARY SERVICING,
        REPAIR, OR CORRECTION. APPLICABLE LAW MAY NOT ALLOW THE EXCLUSION OF
        IMPLIED WARRANTIES, SO THE ABOVE EXCLUSION MAY NOT FULLY APPLY TO YOU.
        (ii) Longbow does not warrant that the Service is compatible with your
        equipment or that the Service, or e-mail sent by Longbow or its
        representative, is free of errors or viruses, worms or “Trojan horses,”
        or any other harmful, invasive, or corrupted files, and is not liable
        for any damage you may suffer as a result of such destructive features.
        You agree that Longbow and its Suppliers, agents, directors, officers,
        employees, representatives, successors, and assigns shall have no
        responsibility or liability for: (i) any injury or damages, whether
        caused by the negligence of Longbow, its parent, or their respective
        affiliates, Suppliers, agents, directors, officers, employees,
        representatives, general partner, subsidiaries, successors, and assigns,
        or otherwise arising in connection with the Service and shall not be
        liable for any lost profits, losses, punitive, incidental or
        consequential damages, or any claim against Longbow by any other party;
        or (ii) any fault, inaccuracy, omission, delay, or any other failure in
        the Service caused by your computer equipment or arising from your use
        of the Service on such equipment. The content of other Web sites,
        services, goods, or advertisements (“Third Party Sites”) that may be
        linked to the Service is not maintained or controlled by Longbow. Our
        provision of links to Third Party Sites is not an endorsement of any
        information, product or service that is offered on or reached through
        such Third Party Site Longbow is not responsible for the availability,
        content, or accuracy of other Web sites, services, or goods that may be
        linked to, or advertised on, the Service. Longbow does not: (a) make any
        warranty, express or implied, with respect to the use of the links
        provided on, or to, the Service; (b) guarantee the accuracy,
        completeness, usefulness or adequacy of any other Web sites, services,
        goods, or advertisements that may be linked to the Service; or (c) make
        any endorsement, express or implied, of any other Web sites, services,
        goods, or advertisements that may be linked to the Service. If you
        decide to leave this site and access the Third Party Sites, you do so at
        your own risk and you should be aware that our terms and policies no
        longer govern. Longbow is also not responsible for the reliability or
        continued availability of the telephone lines, wireless services,
        communications media, and equipment you use to access the Service. You
        understand that Longbow and/or third-party contributors to the Service
        may choose at any time to inhibit or prohibit their content from being
        accessed under the Terms of Service. (iii) You acknowledge that: (i) the
        Service is provided for information purposes only and is not intended
        for trading purposes; (ii) the Service may include certain information
        taken from stock exchanges and other sources from around the world;
        (iii) Longbow does not guarantee the sequence, accuracy, completeness,
        or timeliness of the Service or any information, facts, views, opinions,
        statements or recommendations contained on this site and/or the Service;
        (iv) the provision of certain parts of the Service is subject to the
        terms and conditions of other agreements to which Longbow is a party;
        (v) none of the information contained on this site constitutes a
        solicitation, offer, opinion, endorsement or recommendation by Longbow
        to buy or sell any security, or to provide legal, tax, accounting, or
        investment advice or services regarding the profitability or suitability
        of any security or investment; and (vi) the information provided on this
        site is not intended for use by, or distribution to, any person or
        entity in any jurisdiction or country where such use or distribution
        would be contrary to law or regulation. Accordingly, anything to the
        contrary herein set forth notwithstanding, Longbow, its Suppliers,
        agents, directors, officers, employees, representatives, successors, and
        assigns shall not, directly or indirectly, be liable, in any way, to you
        or any other person for any: (a) inaccuracies or errors in or omissions
        from the Service including, but not limited to, quotes and financial
        data; (b) delays, errors, or interruptions in the transmission or
        delivery of the Service; or (c) loss or damage arising therefrom or
        occasioned thereby, or by any reason of nonperformance. (iv) UNDER NO
        CIRCUMSTANCES, INCLUDING BUT NOT LIMITED TO NEGLIGENCE, SHALL LONGBOW,
        ITS PARENTS, AFFILIATES, SUBSIDIARIES, SUPPLIERS, AGENTS, DIRECTORS,
        OFFICERS, EMPLOYEES, REPRESENTATIVES, SUCCESSORS, LICENSORS OR ASSIGNS
        BE LIABLE TO YOU OR ANY THIRD PERSON FOR DAMAGES OF ANY KIND, WHETHER
        BASED IN TORT, CONTRACT, STRICT LIABILITY OR OTHERWISE, INCLUDING,
        WITHOUT LIMITATION, ANY DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL,
        SPECIAL, PUNITIVE, OR EXEMPLARY DAMAGES EVEN IF LONGBOW HAS BEEN ADVISED
        SPECIFICALLY OF THE POSSIBILITY OF SUCH DAMAGES, ARISING IN ANY WAY FROM
        OR IN CONNECTION WITH THIS SITE, THE SERVICE, USE OF OR INABILITY TO USE
        THE SERVICE OR ANY LINKS OR ITEMS ON THE SERVICE OR ANY PROVISION OF THE
        Terms of Service, SUCH AS, BUT NOT LIMITED TO, LOSS OF REVENUE OR
        ANTICIPATED PROFITS OR LOST BUSINESS. APPLICABLE LAW MAY NOT ALLOW THE
        LIMITATION OR EXCLUSION OF LIABILITY OR INCIDENTAL OR CONSEQUENTIAL
        DAMAGES. IN NO EVENT SHALL LONGBOW’S TOTAL LIABILITY TO YOU FOR ALL
        DAMAGES, LOSSES AND CAUSES OF ACTION (WHETHER IN CONTRACT OR TORT,
        INCLUDING BUT NOT LIMITED TO, NEGLIGENCE) EXCEED THE AMOUNT PAID BY YOU,
        IF ANY, FOR ACCESSING THIS SITE. BY ACCESSING THIS SITE, YOU UNDERSTAND
        THAT YOU MAY BE WAIVING RIGHTS WITH RESPECT TO CLAIMS THAT ARE AT THIS
        TIME UNKNOWN OR UNSUSPECTED, AND IN ACCORDANCE WITH SUCH WAIVER, YOU
        ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND, AND HEREBY EXPRESSLY
        WAIVE, THE BENEFITS OF SECTION 1542 OF THE CIVIL CODE OF CALIFORNIA, AND
        ANY SIMILAR LAW OF ANY STATE OR TERRITORY, WHICH PROVIDES AS FOLLOWS: “A
        GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT
        KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING
        THE RELEASE, WHICH IF KNOWN BY HIM OR HER MUST HAVE MATERIALLY AFFECTED
        HIS OR HER SETTLEMENT WITH THE DEBTOR.” You hereby waive any and all
        rights you have or may have under California Civil Code Section 1542,
        and/or any similar provision of law or successor statute to it, with
        respect to any claims you may have in connection with this site or these
        Terms of Service. In connection with this waiver and release, you
        acknowledge that you are aware that you may hereafter discover claims
        presently unknown or unsuspected, or facts in addition to or different
        from those which you now know or believe to be true. Nevertheless, you
        intend by these Terms of Service to release fully, finally and forever
        all such matters under these Terms of Service In furtherance of such
        intention, the releases set forth in these Terms of Service shall be and
        shall remain in effect as full and complete releases notwithstanding the
        discovery or existence of any such additional or different claims or
        facts relevant hereto. 8. Your Authority to Agree to this Terms of
        Service. You represent, warrant and covenant that: (i) you have the
        power and authority to enter into this agreement; and (ii) you are at
        least eighteen (18) years old. 9. Sponsor Content. (i) What Is Sponsor
        Content? “Sponsor Content” consists of: (i) all paid-for content created
        by the Longbow custom content team (“Longbow Custom Content”) in
        collaboration with advertisers, and served by or appears in any Longbow
        medium and (ii) paid-for content supplied by advertisers that is served
        by or appears in any Longbow medium. The foregoing categories include
        any paid-for content purchased under the AAAA/IAB Standard Terms and
        Conditions. (ii) Standards And Procedures For Sponsor Content In
        addition to the general advertising guidelines established by Longbow,
        the standards listed below apply to Sponsor Content. • All Sponsor
        Content, regardless of platform, will comply with Longbow’s guiding
        principles: • Transparency. All Sponsor Content and marketing messages
        will be clearly and distinctly differentiated from independent news
        content. • Independence. No Longbow journalist will participate in the
        production, editing or promotion of customized content or an
        advertorial. Sponsor agenda and/or concern will neither dictate nor
        delay editorial direction. • Editorial judgment. Longbow maintains the
        right to reject any program, advertiser or speaker whose presence would
        compromise the Longbow brand. • All Sponsor Content will be
        appropriately labeled and distinguished from Longbow editorial content
        in form, function and placement through the use of different type fonts,
        colors and graphics. • Paid programming, advertorials, and sponsored
        programs/segments will be clearly and prominently labelled as
        advertising. No Sponsored Content will imply endorsement of any product
        or service by Longbow, nor will it feature any recognizable Longbow
        names or logos. • Longbow may, in its sole discretion, allow the use of
        a Longbow Custom Content logo to be used in Sponsor Content. The design
        and placement of such logo will be at the discretion of Longbow, and any
        and all such uses shall be subject to Longbow’s prior written approval.
        • All Sponsor Content must be approved in advance and in writing by a
        Longbow Custom Content editor before it appears on any Longbow medium. •
        Sponsor Content is neither produced by nor contributed to by any
        editorial team member of any Longbow medium, nor does it necessarily
        reflect the views of the editors of any Longbow medium. A disclaimer
        similar to the following will be included with all Sponsor Content: “A
        sponsor paid for the creation and placement of the content on this page.
        No editorial member of any Longbow medium contributed to any part of its
        creation, and it does not necessarily reflect the editorial views of
        Longbow or any of its affiliated entities.” • Longbow may, in its sole
        discretion, include a more detailed disclaimer with certain Sponsor
        Content. • Longbow reserves the right to refuse or remove any program,
        advertiser or speaker that in any way: (i) disparages, defames or
        discredits Longbow or its products or services or otherwise compromises-
        in quality or presence- Longbow’s brand or (ii) is false, misleading,
        deceptive or illegal. • Where Sponsor Content allows user participation,
        the moderation and functionality of this element will be determined and
        implemented solely by Longbow and will be subject to the general Terms
        of Service for the applicable Longbow medium. • In the case of Sponsored
        events, sponsors will be clearly identified to all on-site participants
        and in marketing materials tied to the relevant conference or event in
        language that indicates their role as underwriters. Longbow does not
        guarantee speaking roles or other on-stage participation for paying
        sponsors and maintains editorial control and veto power. 10.
        Indemnification. You agree, at your own expense, to indemnify, defend
        and hold harmless Longbow, its Suppliers, agents, directors, officers,
        employees, representatives, successors, and assigns from and against any
        and all claims, damages, liabilities, costs, and expenses, including
        reasonable attorneys’ and experts’ fees, arising out of or in connection
        with the Service, or any links on the Service, including, but not
        limited to: (i) your use or someone using your computer’s use of the
        Service; (ii) use by someone using your account; (iii) a violation of
        the Terms of Service by you or anyone using your computer (or account,
        where applicable); (iv) a claim that any use of the Service by you or
        someone using your computer (or account, where applicable) infringes any
        intellectual property right of any third party, or any right of privacy
        or publicity, is libelous or defamatory, or otherwise results in injury
        or damage to any third party; (v) any deletions, additions, insertions
        or alterations to, or any unauthorized use of, the Service by you or
        someone using your computer (or account, where applicable); (vi) any
        misrepresentation or breach of representation or warranty made by you
        contained herein; or (vii) any breach of any covenant or agreement to be
        performed by you hereunder. You agree to pay any and all costs, damages,
        and expenses, including, but not limited to, reasonable attorneys’ fees
        and costs awarded against or otherwise incurred by or in connection with
        or arising from any such claim, suit, action, or proceeding attributable
        to any such claim. Longbow reserves the right, at its own expense, to
        assume the exclusive defense and control of any matter otherwise subject
        to indemnification by you, in which event you will fully cooperate with
        Longbow in asserting any available defense. You acknowledge and agree to
        pay Longbow’s reasonable attorneys’ fees incurred in connection with any
        and all lawsuits brought against you by Longbow under the Terms of
        Service and any other terms and conditions of service on this site,
        including without limitation, lawsuits arising from your failure to
        indemnify Longbow pursuant to the Terms of Service. 11. Termination. (a)
        You may terminate the Terms of Service, with or without cause and at any
        time, by discontinuing your use of the Service and destroying all
        materials obtained from the Service. (b) You agree that, without notice,
        Longbow may terminate the Terms of Service, or suspend your access to
        the Service, with or without cause at any time and effective
        immediately. The Terms of Service will terminate immediately without
        notice from Longbow if you, in Longbow’s sole discretion, fail to comply
        with any provision of the Terms of Service. (c) Longbow shall not be
        liable to you or any third party for the termination or suspension of
        the Service, or any claims related to the termination or suspension of
        the Service. Upon termination of the Terms of Service by you or Longbow,
        you must discontinue your use of the Service and destroy promptly all
        materials obtained from the Service and any copies thereof. Longbow will
        determine your compliance with the Terms of Service in its sole
        discretion and its decision shall be final and binding and not subject
        to challenge or appeal. Any violation of the Terms of Service may result
        in restrictions on your access to all or part of this site and may be
        referred to law enforcement authorities. No changes to or waiver of any
        part of the Terms of Service shall be of any force or effect unless
        formally posted or made in writing and signed by a duly authorized
        officer of Longbow. Upon termination of your membership or access to
        this site, or upon demand by Longbow, you must destroy all materials
        obtained from this site and all related documentation and all copies and
        installations thereof. You are advised that Longbow will aggressively
        enforce its rights to the fullest extent of the law. 12. Non-United
        States Residents & Jurisdictional Issues. (i) Longbow operates this site
        in the United States. Longbow makes no representation that the Service,
        including merchandise offered for sale on this site and their
        copyrights, trademarks, patents, and licensing arrangements, are
        appropriate or available for use in locations other than the United
        States. If you access this site from locations outside of the U.S. you
        do so on your own initiative and at your own risk, and you are solely
        responsible for compliance with local laws, if and to the extent local
        laws are applicable. (ii) This site is controlled and operated by
        Longbow from its offices within the State of New York, United States.
        Longbow makes no representation that materials in this site are
        appropriate or available for use in other locations. 13. Governing Law.
        The Terms of Service shall be governed and construed in accordance with
        the laws of the United States and the State of New York, without giving
        effect to conflicts-of-law principles thereof. With respect to any
        disputes or claims not subject to arbitration, you agree to submit to
        the personal jurisdiction of the state and federal courts located in New
        York County in the State of New York with respect to any legal
        proceedings that may arise in connection with the Service or from a
        dispute as to the interpretation or breach of the Terms of Service. 14.
        Arbitration. By using this site in any way, you unconditionally consent
        and agree that: (1) any claim, dispute, or controversy (whether in
        contract, tort, or otherwise) you may have against Longbow and/or its
        parent, subsidiaries, affiliates and each of their respective current or
        former members, officers, directors and employees (all such individuals
        and entities collectively referred to herein as the “Longbow Entities”)
        arising out of, relating to, or connected in any way with the website or
        the determination of the scope or applicability of this agreement to
        arbitrate, will be resolved exclusively by final and binding arbitration
        administered by JAMS and conducted before a sole arbitrator in
        accordance with the rules of JAMS; (2) this arbitration agreement is
        made pursuant to a transaction involving interstate commerce, and shall
        be governed by the Federal Arbitration Act (“FAA”), 9 U.S.C. §§ 1-16;
        (3) the arbitration shall be held in New York City, New York; (4) the
        arbitrator’s decision shall be controlled by the terms and conditions of
        these Terms of Service and any of the other agreements referenced herein
        that the applicable user may have entered into in connection with the
        website; (5) the arbitrator shall apply New York law consistent with the
        FAA and applicable statutes of limitations, and shall honor claims of
        privilege recognized at law; (6) there shall be no authority for any
        claims to be arbitrated on a class or representative basis, arbitration
        can decide only your and/or the applicable Longbow Entity’s individual
        claims, and the arbitrator may not consolidate or join the claims of
        other persons or parties who may be similarly situated; (7) the
        arbitrator shall not have the power to award punitive damages against
        you or any Longbow Entity; (8) in the event that the administrative fees
        and deposits that must be paid to initiate arbitration against any
        Longbow Entity exceed $125 USD, and you are unable (or not required
        under the rules of JAMS) to pay any fees and deposits that exceed this
        amount, Longbow agrees to pay them and/or forward them on your behalf,
        subject to ultimate allocation by the arbitrator. In addition, if you
        are able to demonstrate that the costs of arbitration will be
        prohibitive as compared to the costs of litigation, Longbow will pay as
        much of your filing and hearing fees in connection with the arbitration
        as the arbitrator deems necessary to prevent the arbitration from being
        cost-prohibitive; and (9) with the exception of subpart (6) above, if
        any part of this arbitration provision is deemed to be invalid,
        unenforceable or illegal, or otherwise conflicts with the rules of JAMS,
        then the balance of this arbitration provision shall remain in effect
        and shall be construed in accordance with its terms as if the invalid,
        unenforceable, illegal or conflicting provision were not contained
        herein. If, however, subpart (6) is found to be invalid, unenforceable
        or illegal, then the entirety of this Arbitration Provision shall be
        null and void, and neither you nor Longbow shall be entitled to
        arbitrate their dispute. For more information on JAMS and/or the rules
        of JAMS, visit their website at www.jamsadr.com. 15. Compliance,
        Reputational, Operational and Other Considerations You represent,
        warrant and covenant to Longbow that none of you or any person who acts
        on your behalf or at your direction shall use (or enable others to use)
        the Services or anything created using the Services in connection with:
        (i) activities relating to nuclear, chemical or biological weapons
        proliferation, terrorism, corruption, undermining of democratic rights
        and government, money laundering, tax evasion or human rights
        violations, or other similarly egregious activities or (ii) in
        connection with activity in, or for the benefit of, Crimea, Syria, Cuba,
        North Korea, or Iran (each, an “Excluded Jurisdiction”). 16. Economic
        Sanctions & Export Controls Notwithstanding any other provision of these
        Terms of Service, Longbow does not represent that the Service or
        anything created using the Service is appropriate for use in any
        particular location or for any or all purposes. Those who choose to
        access the Service do so on their own initiative and are responsible for
        compliance with all applicable laws. You represent, warrant and covenant
        to Longbow that none of you or any person who acts on your behalf or at
        your direction shall use (or enable others to use) the Service, any
        software included in or downloaded from the Service or anything created
        using the Service in connection with activity: (i) in, or for the
        benefit of, any country or region with respect to which the United
        Nations, United States, European Union and/or United Kingdom (the
        “Sanctioning Authorities”) maintains sanctions prohibiting all or
        substantially all shipment or provision of services, goods, technology
        or software (a “Sanctioned Jurisdiction”); (ii) to, or for the benefit
        of, the government of an Excluded Jurisdiction or a Sanctioned
        Jurisdiction or a person located in or normally resident of an Excluded
        Jurisdiction or a Sanctioned Jurisdiction; (iii) involving or benefiting
        a government or person whose assets a Sanctioning Authority has blocked
        or to which a Sanctioning Authority restricts the shipment or provision
        of services, goods, technology or software (a “Prohibited Party”); (iv)
        to the extent applicable, for the purpose of transacting in, providing
        financing for, or otherwise dealing in prohibited equity or debt of, or
        extending credit to, persons identified by (or owned or controlled,
        whether individually or in aggregate, by persons identified by) any
        Sanctioning Authority as being subject to sanctions prohibiting such
        activities; or (v) for any purpose that would be prohibited under the
        economic sanctions of any Sanctioning Authority. Each time you receive
        or use the Service or anything created using the Service, you shall be
        deemed to represent and warrant to Longbow and its affiliates that none
        of you, any person who acts on your behalf or at your direction, or any
        person on whose behalf you are acting, is: (i) located in or normally a
        resident of, or the government of, any Excluded Jurisdiction or
        Sanctioned Jurisdiction; or (ii) a Prohibited Party. 17. Miscellaneous.
        You accept that Longbow has the right to change the content or technical
        specifications of any aspect of the Service at any time in Longbow’s
        sole discretion. You further accept that such changes may result in your
        being unable to access the Service. The failure of Longbow to exercise
        or enforce any right or provision of the Terms of Service shall not
        constitute a waiver of such right or provision. Sections 2 through 10,
        11(c), and 12 through 20 shall survive any termination of the Terms of
        Service. 18. Headings. The section titles in the Terms of Service are
        used solely for the convenience of you and Longbow and have no legal or
        contractual significance. 19. Severability. If any provision of the
        Terms of Service is found invalid or unenforceable, that provision will
        be enforced to the maximum extent permissible, and the other provisions
        of the Terms of Service will remain in force. 20. Entire Agreement. The
        Terms of Service and any other terms and conditions of service on this
        site, and its successor, constitute the entire agreement between you and
        Longbow, govern your use of the Service, and supersede all prior or
        contemporaneous written or oral agreements between the parties with
        respect to the subject matter hereof. These Terms of Service may not be
        amended, nor any obligation waived, without Longbow’s written
        authorization.
        <h2>B. SUBSCRIPTION TERMS</h2>
        1. Payment Policy Subscriptions purchased via
        myLongbow.com/subscriptions are billed either monthly or quarterly. Your
        selected payment method will be charged automatically on a recurring
        monthly or quarterly basis. Your subscription will be renewed
        automatically, and you will be charged in advance of each billing cycle
        unless you cancel. If you subscribed under an introductory offer, at the
        end of your introductory period, your payment method on file will be
        charged automatically each month for the full price of your
        subscription. All Subscriptions are listed in US Dollars ($). 2.
        Cancellation & Refund Policy In order to change or cancel your
        subscription, please sign in to your account & select “Cancel“ We
        reserve the right to issue refunds or credits at our sole discretion. If
        we do issue a refund or credit, we are under no obligation to issue the
        same or similar refund in the future. If you purchased your subscription
        through a third party, please refer to any terms and conditions provided
        to you in connection with purchase. a. Monthly Subscriptions When
        cancelling a monthly subscription, all future charges associated with
        future months of your subscription will be cancelled. You may notify us
        of your intent to cancel at any time; your cancellation will become
        effective at the end of your current monthly billing period. You will
        not receive a refund; however your subscription access and/or delivery
        and accompanying subscriber benefits will continue for the remainder of
        the current monthly billing period. b. Quarterly Subscriptions When
        cancelling an quarterly subscription, all future charges associated with
        future years of your subscription will be cancelled. You may notify us
        of your intent to cancel at any time; your cancellation will become
        effective at the end of your current quarterly billing period. You will
        not receive a refund, prorated or otherwise, for the remainder of the
        quarterly term. However, your subscription access and/or delivery and
        accompanying subscriber benefits will continue for the remainder of the
        current quarterly billing period. 3. Promotional Discounts &
        Introductory Offers From time to time, we offer introductory pricing at
        a reduced rate for a specified period of time (“Introductory Offers”).
        Introductory Offers can only be redeemed by first time subscribers to
        MyLongbow.com. If you do not qualify for an Introductory Offer, we
        reserve the right to reject your order to reflect current subscriber
        pricing. Longbow may determine your eligibility for an Introductory
        Offer at any time without prior notice and with no liability, to the
        extent permitted under applicable law. For all Introductory Offers, we
        will require you to provide payment details to start a Subscription to
        myLongbow.com. By providing such details you agree that we will
        automatically charge the full price of the Paid Subscription on the
        first day following the end of the Introductory Offer on a recurring
        monthly basis or another interval that we disclose to you in advance. IF
        YOU DO NOT WANT THIS CHARGE, YOU MUST CANCEL YOUR SUBSCRIPTION BEFORE
        THE END OF THE INTRODUCTORY PERIOD BY CONTACTING SUPPORT@MYLONGBOW.COM.
        IF YOU RECEIVED YOUR INTRODUCTORY OFFER THROUGH A THIRD PARTY, YOU MUST
        CANCEL THE APPLICABLE PAID SUBSCRIPTION THROUGH THE THIRD PARTY. 4.
        Acceptable Use Access for Authorized Subscribers will be granted to a
        Longbow account associated with their Company/Organizational specific
        email address. Subscriber shall not use Longbow’s name, logo, trademark,
        service mark or other designation in any manner without the prior
        written consent of Longbow. Longbow hereby grants to Client a
        non-exclusive, non-transferable, non-sub-licensable license to allow its
        Authorized Subscribers to consume Longbow content for personal use and
        for internal work-related, research, and general awareness purposes.
        <h2 style={{ padding: "4px auto" }}>
          C. LINKING AND FRAMING TERMS AND CONDITIONS
        </h2>
        YOU MAY NOT FRAME THIS WEB SITE, OR ANY PORTION THEREOF, EXCEPT AS
        PROVIDED HEREIN. IF YOU LINK TO THIS WEB SITE, OR ANY PORTION THEREOF,
        WE REQUIRE THAT YOU FOLLOW THESE TERMS. 1. Intellectual Property. Upon
        linking to this Web site pursuant to the Terms of Service, you will be
        granted a non-exclusive, non-transferable, royalty-free sub-license to
        use the Longbow mark owned by Longbow solely for providing an
        underlined, textual link from your Web site to myLongbow.com. No other
        use of Longbow’s marks, names or logos is permitted without express
        written permission from Longbow. 2. Restrictions on Linking to this Web
        Site. Without limiting other provisions contained in our Terms of
        Service, you may include a link(s) on your Web site to myLongbow.com’s
        publicly accessible Web pages (i.e., any Web page which does not require
        a login and password and/or restrict access). You may not link to
        MyLongbow.com any site containing an inappropriate, profane, defamatory,
        infringing, obscene, indecent or unlawful topic, name, material or
        information that violates any applicable intellectual property,
        proprietary, privacy or publicity rights, or is otherwise deemed
        inappropriate, as determined by Longbow in its sole discretion. The link
        to this site must not damage, dilute or tarnish the goodwill associated
        with any Longbow names and/or intellectual property, nor may the link
        create the false appearance that your website and/or organization is
        sponsored, endorsed by, affiliated and/or associated with Longbow.
        Longbow reserves the right, in its sole discretion, to terminate a link
        with any website for any reason or no reason at all, including without
        limitation any website that Longbow deems to be inappropriate or
        inconsistent with or antithetical to this site and/or these Terms of
        Service. 3. Restrictions on Framing Activities. Longbow is concerned
        about the integrity of this Web site when it is accessed in a manner
        solely determined by third parties or viewed in a setting solely created
        by third parties. Specifically, Longbow is concerned with activities
        such as bringing up or presenting content of this Web site within
        another Web site (“framing”). In this regard, without limiting the
        provisions contained in our Terms of Service, you may not frame any Web
        page from MyLongbow.com, except with our express written permission.
        Further, you may not archive, cache, or mirror any MyLongbow.com Web
        page or portions of a Web page. If you would like to use, reprint,
        frame, or redistribute any myLongbow.com content other than as permitted
        herein, you must request permission from Longbow by writing to
        support@myLongbow.com. Please include: (a) your name, e-mail address,
        and telephone number; (b) the name of your company; (c) the Web site
        address(es) where the proposed use will occur; and (d) specific details
        about the contemplated linking or framing activities, including the
        content or Web page(s) of this Web site which you would like to use.
        <p ref={bottomEndRef} style={{ paddingTop: 15 }}>
          Longbow Trade Signals, LLC Terms of Service
        </p>
      </div>
      <div
        onClick={scrollToBottom}
        style={{
          position: "fixed",
          bottom: 4,
          textAlign: "center",
          left: "auto",
          right: "auto",
          marginLeft: "22%",
          cursor: "pointer",
          fontSize: "18px",
          backgroundColor: "#75ce41",
          color: "white",
          borderRadius: "3px",
          padding: "0 1%",
        }}
      >
        <i className="fas fa-arrow-down arrow-down" />
      </div>
    </div>
  );
}
